/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Priced_NoInputs */

const id_tld_pricing_priced_no = /** @type {(inputs: Tld_Pricing_Priced_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum ada harga`)
};

const en_tld_pricing_priced_no = /** @type {(inputs: Tld_Pricing_Priced_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not priced yet`)
};

/**
* | output |
* | --- |
* | "Not priced yet" |
*
* @param {Tld_Pricing_Priced_NoInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_priced_no = /** @type {((inputs?: Tld_Pricing_Priced_NoInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Priced_NoInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_priced_no(inputs)
	return id_tld_pricing_priced_no(inputs)
});